import classNames from 'classnames';
import type {FC} from 'react';
import {CommonLink} from '../CommonLink';

type Props = {
  href: string;
  label: string;
  className?: string;
};

export const MenuButtonItem: FC<Props> = ({href, label, className}) => {
  return (
    <CommonLink
      href={href}
      className={classNames(
        'border border-primary-1 rounded p-4 text-center text-primary-1',
        className,
      )}
    >
      {label}
    </CommonLink>
  );
};
